module.exports = __webpack_public_path__ + "static/media/dp-to-bringg.648a2924.svg";